import axios from "axios";

export default axios.create({
  baseURL: "https://api.manoshala.com/dashboard/",
  headers: {
    "Content-type": "application/json",
  }
});